exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na.dropdown-item[data-v-b6170566] {\n    padding: 10px !important;\n}\n.tag[data-v-b6170566] {\n    margin: 0 !important;\n}\n", ""]);

// exports
